"use client";

import { Clock } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface TimeSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  options: string[];
  placeholder: string;
  disabled?: boolean;
  disabledTime?: (time: string) => boolean;
  emptyMessage?: string;
}

export default function TimeSelect({
  value,
  onValueChange,
  options,
  placeholder,
  disabled = false,
  disabledTime,
  emptyMessage,
}: TimeSelectProps) {
  return (
    <Select value={value} onValueChange={onValueChange} disabled={disabled}>
      <SelectTrigger className="w-full px-3">
        <div className="flex items-center text-sm w-full">
          <Clock className="h-4 w-4 mr-2 shrink-0" />
          <SelectValue placeholder={placeholder} />
        </div>
      </SelectTrigger>
      <SelectContent className="max-h-50">
        {options.length > 0 ? (
          options.map((time) => (
            <SelectItem
              key={time}
              value={time}
              disabled={disabledTime?.(time)}
            >
              {time}
            </SelectItem>
          ))
        ) : (
          <div className="px-2 py-1.5 text-sm text-gray-500">
            {emptyMessage}
          </div>
        )}
      </SelectContent>
    </Select>
  );
}
